<template>
  <nav class="nav navbar navbar-dark fixed-bottom d-flex d-xl-none bg-dark">
    <div class="navbar-nav w-full">
      <div class="row">
        <router-link
          :to="dashboardPage"
          class="nav-item col nav-link d-flex flex-column align-items-center"
        >
          <i class="pz-icon icon-study text-muted"></i>
          <small>课程学习</small>
        </router-link>
        <router-link
          :to="notesPage"
          class="nav-item col nav-link d-flex flex-column align-items-center"
        >
          <i class="pz-icon icon-note text-muted"></i>
          <small>我的笔记</small>
        </router-link>
        <router-link
          :to="eventsPage"
          class="nav-item col nav-link d-flex flex-column align-items-center"
        >
          <i class="pz-icon icon-activity text-muted"></i>
          <small>我的考试</small>
        </router-link>
        <router-link
          :to="settingPage"
          class="nav-item col nav-link d-flex flex-column align-items-center"
        >
          <i class="pz-icon icon-person text-muted"></i>
          <small>用户中心</small>
        </router-link>
      </div>
    </div>
  </nav>
</template>
<script>
import * as routes from '../constants/routes';
export default {
  name: 'TabBar',
  data: () => {
    return {
      settingPage: routes.SETTING_PAGE,
      dashboardPage: routes.DASHBOARD_PAGE,
      notesPage: routes.NOTES_PAGE,
      eventsPage: routes.EVENTS_PAGE,
      CoursePage: routes.MAIN_MODE_COURSE_PAGE,
      MiniCoursePage: routes.MINI_MODE_COURSE_PAGE,
      FreeCoursePage: routes.FREE_MODE_COURSE_PAGE,
    };
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
